export default {
    title: "Importar clientes",
    upload_label: "Por favor envie um arquivo .csv seguindo esse modelo:",
    loading_message: "Enviando dados, isso pode levar alguns minutos...",
    file_size_error: "O arquivo deve ter no maximo {0}MB",
    csv_error: "Ocorreu um erro ao ler o CSV, confira se o arquivo e valido",
    include_time: "Contem a hora tambem",
    format: "Formato",
    decimal_separator: "Separador Decimal",
    full_name: "Contem o nome completo",
    default_prefix: "DDD Padrao",
    update_profiles: "Atualizar cadastros",
    summary: {
        new_clients: "Novos clientes",
        updated_clients: "Clientes atualizados",
    },
    cancel: "Cancelar",
    next: "Proximo",
    back: "Voltar",
    import: "Importar",
    close: "Fechar",
    queued_message: "Importação enviada! Ela será processada em segundo plano.",
    queued_link: "Acompanhar no histórico de importações",
    open_button: "Importar clientes",
    columns: {
        client_external_id: "Id do cliente",
        first_name: "Nome",
        last_name: "Sobrenome",
        whatsapp: "Telefone",
        email: "E-mail",
        birthdate: "Data de Nascimento",
    },
};
